import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'findBy',
  standalone: true,
})
export class FindByPipe implements PipeTransform {
  transform<T>(array: T[] | undefined, property: keyof T, value: unknown): undefined | T {
    if (!array) return undefined;
    return array.find((obj) => obj[property] === value);
  }
}
